
import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { PatientV4Login } from 'connect/saga/handlers/user/patient-v4-login';

import { selectDataLoadingUser } from 'connect/selectors';
import { useHookResult } from 'utils/customHooks/use-hook-result';
import Logger from 'utils/Logger';

const MAX_ATTEMPTS = 5;
const RETRY_DELAY = 1000;

export const usePatientV4Login = () => {
  const dispatch = useDispatch();
  const state = useSelector(PatientV4Login.selector);
  const isLoadingUser = useSelector(selectDataLoadingUser);

  const [numAttempts, setNumAttempts] = useState(0);

  const hasFailed = numAttempts >= MAX_ATTEMPTS;

  useEffect(() => {
    if (state.success || state.loading || hasFailed || isLoadingUser) {
      return;
    }

    if (state.error) {
      Logger.error('Login to patient v4 app failed', state.error);
    }

    const timeout = setTimeout(() => {
      // Try logging out first if we've failed before
      const shouldLogout = Boolean(state.error);
      dispatch(PatientV4Login.createAction({ shouldLogout }));
      setNumAttempts((prev) => prev + 1);
    }, RETRY_DELAY);

    return () => clearTimeout(timeout);
  }, [numAttempts, state.success, state.loading, dispatch, state.error, hasFailed, isLoadingUser]);

  return useHookResult({
    isLoading: state.loading,
    hasSucceeded: state.success,
    hasFailed,
  });
};
